import { FC, HTMLAttributes } from 'react';

export const ReactComponent: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 15L10.3536 14.6464L10.2071 14.5H10V15ZM4 15L4 15.5H4V15ZM3 14H2.5H3ZM4 3V2.5V3ZM16 3V2.5V3ZM17 4H17.5H17ZM16 15V15.5V15ZM14 15V14.5H13.5V15H14ZM14 17.793L14.5 17.793V17.793H14ZM13.1465 18.1465L12.7929 18.5L12.793 18.5001L13.1465 18.1465ZM10 15V14.5H4V15V15.5H10V15ZM4 15L4 14.5C3.72386 14.5 3.5 14.2761 3.5 14H3H2.5C2.5 14.8284 3.17157 15.5 4 15.5L4 15ZM3 14H3.5V4H3H2.5V14H3ZM3 4H3.5C3.5 3.72386 3.72386 3.5 4 3.5V3V2.5C3.17157 2.5 2.5 3.17157 2.5 4H3ZM4 3V3.5H16V3V2.5H4V3ZM16 3V3.5C16.2761 3.5 16.5 3.72386 16.5 4H17H17.5C17.5 3.17157 16.8284 2.5 16 2.5V3ZM17 4H16.5V14H17H17.5V4H17ZM17 14H16.5C16.5 14.2761 16.2761 14.5 16 14.5V15V15.5C16.8284 15.5 17.5 14.8284 17.5 14H17ZM16 15V14.5H14V15V15.5H16V15ZM14 15H13.5V17.793H14H14.5V15H14ZM14 17.793L13.5 17.7929L13.5 17.7929L13.1465 18.1465L12.793 18.5001C13.4229 19.1299 14.4999 18.6838 14.5 17.793L14 17.793ZM13.1465 18.1465L13.5 17.7929L10.3536 14.6464L10 15L9.64645 15.3536L12.7929 18.5L13.1465 18.1465Z"
      fill="#24275B"
    />
    <rect x="7" y="8.5" width="6" height="1" rx="0.5" fill="#24275B" />
    <rect
      x="9.5"
      y="12"
      width="6"
      height="1"
      rx="0.5"
      transform="rotate(-90 9.5 12)"
      fill="#24275B"
    />
  </svg>
);
